import { render, staticRenderFns } from "./ProviderListTable.vue?vue&type=template&id=39e17057&scoped=true"
import script from "./ProviderListTable.vue?vue&type=script&lang=js"
export * from "./ProviderListTable.vue?vue&type=script&lang=js"
import style0 from "./ProviderListTable.vue?vue&type=style&index=0&id=39e17057&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e17057",
  null
  
)

export default component.exports